import React from "react";
import {
  Grid,
  Typography,
  Box,
  Link,
  styled,
  Divider,
} from "@mui/material";
import Logo from "assets/images/logo/PrimeSolutionAllWhiteLogo.png";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import MailOutlineSharpIcon from "@mui/icons-material/MailOutlineSharp";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import FaxOutlinedIcon from "@mui/icons-material/FaxOutlined";

const StyledText = styled(Typography)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  textAlign: "left",
}));

const StyledFooter = styled(Grid)(({ theme }) => ({
  padding: "2rem",
  marginTop: "auto",
  backgroundColor: theme.palette.primary.black,
  color: theme.palette.gray.main,
  // position: "fixed", // This can also be 'fixed' if 'sticky' doesn't work as expected
  // bottom: 0,
  width: "100%",
  // position: "absolute",
  "& .inner-footer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      textAlign: "center",
    },
    "& .img-box": {
      display: "flex",
      justifyContent: "center",
      height: "30px",
      [theme.breakpoints.down("md")]: {
        marginBottom: "20px",
      },
    },
    "& .text-box": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      gap: "2rem",
      alignItems: "start",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
      },
      "& .text-column": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "5px",
      },
    },
  },
}));

const Footer = () => {
  return (
    <StyledFooter item xs={12}>
      <Box className="inner-footer">
        <Box className="img-box">
          <img src={Logo} alt="PrimeSolution" />
        </Box>
        <Box className="text-box">
          <Box className="text-column">
            <StyledText variant="small">
              <HomeSharpIcon fontSize="12px" />
              경기도 안양시 동안구 시민대로 327번길 24 (관양동) 더프라임빌딩 2층
            </StyledText>
            <StyledText variant="small">
              <LocalPhoneOutlinedIcon fontSize="12px" /> 031-464-1051
            </StyledText>
            <StyledText variant="small">
              <FaxOutlinedIcon fontSize="12px" /> 031-464-1061 (Fax)
            </StyledText>

            <StyledText variant="small">
              <MailOutlineSharpIcon fontSize="12px" />
              <Link
                href="mailto:SPD@primepowersolutions.com"
                sx={{ color: "gray.main" }}
              >
                SPD@primepowersolutions.com
              </Link>
            </StyledText>
          </Box>
          {/* {isMobile ? (
            <Divider color="white" />
          ) : ( */}
          <Divider orientation="vertical" flexItem color="gray" />
          {/* )} */}
          <Box className="text-column">
            <StyledText variant="small">
              <HomeSharpIcon fontSize="12px" />
              3960 West Point Loma Blvd. Ste. H San Diego, CA 92110 USA
            </StyledText>
            <StyledText variant="small">
              <LocalPhoneOutlinedIcon fontSize="12px" /> +1-858-282-0901
            </StyledText>
          </Box>
        </Box>
      </Box>
      <Typography variant="small" align="center" mt={3}>
        Copyright © PrimeSolution {new Date().getFullYear()}.
      </Typography>
    </StyledFooter>
  );
};

export default Footer;
